export default __webpack_public_path__ + "static/4-111792d1fb0392f6992b3ba0f12fe9a6.png";